import { useContext } from 'react';

import { XYChartAnnotationsShownIndicatorsContext } from '../context/XYChartAnnotationsShownIndicators.context.js';

export const useXYChartAnnotationsShownIndicators = () => {
  const indicatorData = useContext(XYChartAnnotationsShownIndicatorsContext);
  if (!indicatorData) {
    throw new Error(
      'useXYChartAnnotationsShownIndicators must be used within XYChartAnnotationsShownIndicatorsContext',
    );
  }
  return indicatorData;
};
